import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MatDialogContent, MatDialogModule } from '@angular/material/dialog';
import { provideTranslationScope, TranslationPipeModule } from '@ogs-gmbh/ngx-translate';

@Component({
  selector: 'app-pending-changes-dialog',
  standalone: true,
  imports: [ MatButtonModule, MatDialogContent, MatDialogModule, TranslationPipeModule ],
  providers: [ provideTranslationScope("shared/pending-changes-dialog") ],
  templateUrl: './pending-changes-dialog.component.html',
  styleUrl: './pending-changes-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PendingChangesDialogComponent {
  private _dialogRef: MatDialogRef<PendingChangesDialogComponent> = inject<MatDialogRef<PendingChangesDialogComponent>>(MatDialogRef);

  onConfirm (): void {
    this._dialogRef.close(true);
  }

  onCancel (): void {
    this._dialogRef.close(false);
  }
}
